import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { useMotionValue, motion } from 'framer-motion';
import { useRef, useState, useMemo, useEffect } from 'react';
import { th } from '@yoweb/ui/styles/utils/theme';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { QuoteIcon } from '@yoweb/ui/components/Icon';
import { Title, Text, QuoteMarketing, Label } from '@yoweb/ui/components/typography';
import { media } from '@yoweb/ui/styles/utils';
import { Container } from '@yoweb/ui/components/containers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SCROLLBAR_OFFSET = 18;
export var TestimonialSection = function TestimonialSection() {
  var _useTranslation = useTranslation('pricing'),
      t = _useTranslation.t;

  var contentRef = useRef(null);
  var constraintsRef = useRef(null);
  var x = useMotionValue(0);

  var _useState = useState(-1),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(false),
      isMouseOver = _useState2[0],
      setMouseOver = _useState2[1];

  var testimonials = useMemo(function () {
    return [{
      text: t('testimonial-section.testimonials.0.text'),
      name: t('testimonial-section.testimonials.0.name')
    }, {
      text: t('testimonial-section.testimonials.1.text'),
      name: t('testimonial-section.testimonials.1.name')
    }, {
      text: t('testimonial-section.testimonials.2.text'),
      name: t('testimonial-section.testimonials.2.name')
    }, {
      text: t('testimonial-section.testimonials.3.text'),
      name: t('testimonial-section.testimonials.3.name')
    }, {
      text: t('testimonial-section.testimonials.4.text'),
      name: t('testimonial-section.testimonials.4.name')
    }];
  }, []);
  useEffect(function () {
    var onResize = function onResize() {
      if (!contentRef.current || !constraintsRef.current) {
        return;
      }

      var parentWidth = constraintsRef.current.offsetWidth;
      var contentWidth = contentRef.current.scrollWidth;
      setWidth(Math.max(contentWidth - parentWidth + 48 + SCROLLBAR_OFFSET, 0));
      x.set(0);
    };

    onResize();
    window.addEventListener('resize', onResize, {
      passive: true
    });
    return function () {
      x.stop();
      window.removeEventListener('resize', onResize);
    };
  }, [x]);
  useEffect(function () {
    var onWheelMove = function onWheelMove(event) {
      // Don't steal y scroll
      if (!isMouseOver || event.deltaX === 0) {
        return;
      }

      x.stop();
      event.preventDefault();

      if (x.get() >= 0 && event.deltaX < 0) {
        x.set(0);
      } else if (x.get() <= -width && event.deltaX > 0) {
        x.set(-width);
      } else {
        x.set(x.get() - event.deltaX);
      }
    };

    window.addEventListener('wheel', onWheelMove, {
      passive: false
    });
    return function () {
      x.stop();
      window.removeEventListener('wheel', onWheelMove);
    };
  }, [x, width, isMouseOver]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BoxContainer, {
      mt: {
        _: 'large2',
        md: 'large3',
        lg: 'xl2'
      },
      mx: "auto",
      "data-testid": "pricing-section-testimonials",
      children: /*#__PURE__*/_jsx(Box, {
        mx: "auto",
        maxWidth: 630,
        px: "normal1",
        children: /*#__PURE__*/_jsx(Title, {
          size: {
            _: 'md',
            md: 'lg',
            lg: 'xl'
          },
          textAlign: "center",
          children: t('testimonial-section.title')
        })
      })
    }), /*#__PURE__*/_jsx(CarouselWrapper, {
      mt: {
        _: 'medium2',
        lg: 'large1'
      },
      children: /*#__PURE__*/_jsx(motion.div, {
        drag: "x",
        dragConstraints: {
          left: -width,
          right: 0
        },
        style: {
          x: x,
          cursor: 'grab'
        },
        whileTap: {
          cursor: 'grabbing'
        },
        onMouseEnter: function onMouseEnter() {
          return setMouseOver(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setMouseOver(false);
        },
        children: /*#__PURE__*/_jsx(TestimonialRow, {
          ref: constraintsRef,
          children: /*#__PURE__*/_jsx(TestimonialItems, {
            ref: contentRef,
            children: testimonials.map(function (testimonial) {
              return /*#__PURE__*/_jsxs(TestimonialCard, {
                "data-testid": "pricing-testimonial",
                children: [/*#__PURE__*/_jsx(QuoteIcon, {
                  variant: "attention"
                }), /*#__PURE__*/_jsx(QuoteMarketing, {
                  size: {
                    _: 'lg',
                    lg: 'xl'
                  },
                  children: testimonial.text
                }), /*#__PURE__*/_jsx(Label, {
                  size: "md",
                  weight: "regular",
                  variant: "muted",
                  children: testimonial.name
                })]
              }, testimonial.name);
            })
          })
        })
      }, "motion-".concat(width))
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Box, {
        mt: "normal1",
        children: /*#__PURE__*/_jsx(Text, {
          size: {
            _: 'sm',
            md: 'md',
            lg: 'lg'
          },
          variant: "muted",
          children: t('testimonial-section.disclaimer')
        })
      })
    })]
  });
}; // Testimonial section components

var TestimonialRow = styled.div.withConfig({
  componentId: "sc-1fnn628-0"
})(["width:100%;margin:0 auto;", ""], media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n  "])), th.getSize('containerWidth')));
var TestimonialItems = styled.div.withConfig({
  componentId: "sc-1fnn628-1"
})(["display:grid;grid-auto-flow:column;gap:", ";justify-items:start;background-color:", ";padding-left:24px;padding-right:24px;", ""], th.getSpace('normal1'), th.getColor('base000'), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    gap: ", ";\n  "])), th.getSpace('normal2')));
var TestimonialCard = styled.div.withConfig({
  componentId: "sc-1fnn628-2"
})(["display:grid;grid-template-rows:min-content 1fr min-content;height:367px;width:312px;background-color:", ";border-radius:", ";padding:", ";grid-gap:", ";align-content:start;", ""], th.getColor('base050'), th.getRadii('large'), th.getSpace('normal3'), th.getSpace('small3'), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 464px;\n    width: 392px;\n  "]))));
var CarouselWrapper = styled(Box).withConfig({
  componentId: "sc-1fnn628-3"
})(["&&{width:100%;max-width:100vmax;overflow:hidden;}"]);
var BoxContainer = styled(Box).withConfig({
  componentId: "sc-1fnn628-4"
})(["&&{max-width:", ";}"], th.getSize('containerWidth'));